<div class="document-component">

    <div *ngIf="!documentContainValue" class="noneDocument">
        {{'document.noneDocument'|translate}}
    </div>


    <div *ngIf="documentContainValue" class="documents">

        <!--{ singleEvent$ | async }-->

        <mat-nav-list>

            <mat-list-item *ngIf="buttonRetour" class="document" (click)="SelectDocumentRetour()" [class.disabled]="isContentLoading">
                <div><i aria-hidden="true" class="fas fa-arrow-left"></i> {{'scaleform.retour'|translate}}</div>
            </mat-list-item>

            <ng-container *ngFor="let document of documentLstToShow">
                <mat-list-item #listItem class="document" [class.highlight]="document.idTitre === selectedDocumentIDTitre" (click)="SelectDocumentEnfant(document, listItem)" [class.disabled]="isContentLoading">
                    <div>
                        {{document.libelle}}
                        <ng-container *ngIf="document.idTitre === selectedDocumentIDTitre">
                            <i class="fa-solid fa-chevron-down portraitDisplay"></i>
                            <i class="fa-solid fa-chevron-right landscapeDisplay"></i>
                        </ng-container>
                    </div>
                </mat-list-item>
                <div *ngIf="dataLocalUrl != undefined && documentContainValue && document.idTitre === selectedDocumentIDTitre" class="pdf">
                    <iframe class="portraitDisplay" [attr.src]="dataLocalUrl" type="application/pdf" title=""></iframe>
                </div>
            </ng-container>

        </mat-nav-list>
    </div>

    <div *ngIf="dataLocalUrl != undefined && documentContainValue" class="pdf">
        <iframe class="landscapeDisplay" width="100%" [attr.src]="dataLocalUrl" type="application/pdf" title=""></iframe>
    </div>

</div>

